import { FC } from "react";
import { Form, Input } from "antd";
import Carrier from "@Components/Carrier/Carrier";
import { withFloatingLabel } from "src/HOC";
import { formatDate } from "src/utility/time";
import CheckOutFieldContent from "../../CheckOutFieldContent/CheckOutFieldContent";
import TripDateSelect from "../../DateSelection/TripDateSelect/TripDateSelect";

const FloatingInput = withFloatingLabel(Input);
const DATE_FORMAT = "ddd, DD MMM YYYY";

const CheckOutComponentMob: FC<any> = ({ name, icon: Icon, label, hasError, disabledDate, className }) => {
  const value = Form.useWatch(name);

  return (
    <Carrier
      label={label}
      renderTrigger={({ open }) => (
        <div className={`border-b border-border-default flex w-full flex-1 items-center gap-1 px-1 ${hasError ? "text-font-danger" : "text-icon-minimal"}`}>
          <Icon className="h-4! w-4!" />
          <FloatingInput
            label={label}
            readOnly
            value={formatDate(value, DATE_FORMAT)}
            onClick={open}
            className="text-font-default! border-none! outline-none! font-semibold shadow-none! pt-5! pb-1! px-3! w-full cursor-pointer"
          />
        </div>
      )}
      renderSheet={({ close }) => (
        <CheckOutFieldContent className="m-0! focus:outline-none! focus-within:ring-0! w-full border-none! font-semibold md:flex-1 [&_.ant-form-item-explain-error]:hidden [&_.ant-form-item-explain-error]:md:block [&_.ant-form-item-explain-error]:md:px-4!">
          <TripDateSelect label={label} icon={Icon} disabledDate={disabledDate} className={className} closeSheet={close} />
        </CheckOutFieldContent>
      )}
    />
  );
};

export default CheckOutComponentMob;
